<!-- Seriennummer einer ObjektPosition holen und falls vorhanden anzeigen -->
<template>

    <span class="ShowSeriennummerWrapper">
        {{ $t("message.show_seriennummer_seriennummer") }}: {{ seriennr }}
    </span>

</template>

<script>

    import axios from 'axios'
    axios.defaults.withCredentials = true

    // Define a new component
    export default {
        name: 'ShowSeriennummer',
        props: {

          position_id: {
              type: Number,
              required: true
          },
          objekt_id: {
            type: Number,
            required: true
          },

        },
        data: function(){
          return {
            seriennr: null
          }
        },
        watch: {
          position_id: function () {
            this.init()
          },
          objekt_id: function () {
            this.init()
          },
        },
        mounted: function () {

          this.init()

        },
        methods: {

          /** hole Seriennummer vom Databroker */
          init: function() {

            if (this.objekt_id && this.position_id) {

              const that    = this
              const url     = process.env.VUE_APP_SERVER_URL + '/datenbroker/getSeriennummer'
              const params  = {
                position_id: this.position_id,
                objekt_id:   this.objekt_id,
              }
              axios ({
                method: 'GET',
                params: params,
                url: url,
              }).then(function (response) {

                that.seriennr = response.data.traplinkedId

              })

            }

          }

        }

    }

</script>
